export function convertPointToPrice(amount: string): string {
    return `${amount ? '£' + (Number(amount) * 0.01).toFixed(2) : 0}`;
}
